import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import Svg4Everybody from 'svg4everybody';

Svg4Everybody();
